/**
 * WordPress dependencies
 */
import { useState, useEffect, useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";

import PatternContext from '../Context/PatternContext';

const PatternlyHeader = () => {

    const patternContext = useContext(PatternContext);

    const [error, setError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const activeItem = (event) => {
        //remove active class.
        let activeItem = document.querySelector('.pat-main-li-active');
        activeItem.classList.remove('pat-main-li-active');

        //add active class.
        event.currentTarget.parentElement.classList.add('pat-main-li-active');

        //remove category active class.
        let activeCategoryItem = document.querySelector('.pat-sidebar-active');
        activeCategoryItem.classList.remove('pat-sidebar-active');

        //active first child.
        let firstCatItem = document.querySelector('.pat-sidebar-ul li:first-child');
        firstCatItem.classList.add('pat-sidebar-active');
    }

    const searchPatterns = (event) => {
        let searchValue = event.currentTarget.value;

        if(searchValue.length > 0 && searchValue.length < 3) {
            return;
        }

        //remove menu active class.
        let activeMenuItem = document.querySelector('.pat-main-li-active');
        activeMenuItem.classList.remove('pat-main-li-active');

        let firstMenuItem = document.querySelector('.pat-main-ul li:first-child');
        firstMenuItem.classList.add('pat-main-li-active');

        //remove category active class.
        let activeCategoryItem = document.querySelector('.pat-sidebar-active');
        activeCategoryItem.classList.remove('pat-sidebar-active');

        let firstCatItem = document.querySelector('.pat-sidebar-ul li:first-child');
        firstCatItem.classList.add('pat-sidebar-active');

        if(searchValue.length === 0) {
            patternContext.setQueryType('all');
            patternContext.setQueryTypeValue(false);
            patternContext.setCurrentPage(1);
            patternContext.setLoadPatternData(true);
            patternContext.setLoadMoreButton(true);
        }else {
            patternContext.setQueryType('search');
            patternContext.setQueryTypeValue(searchValue);
            patternContext.setCurrentPage(1);
            patternContext.setLoadPatternData(true);
            patternContext.setLoadMoreButton(true);
        }
    };

    const getDefaultData = (event) => {
        //active item.
        activeItem(event);

        patternContext.setQueryType('all');
        patternContext.setQueryTypeValue(false);
        patternContext.setCurrentPage(1);
        patternContext.setLoadPatternData(true);
        patternContext.setLoadMoreButton(true);
    }

    const getPatternsByType = (event) => {

        //active item.
        activeItem(event);

        let type = event.currentTarget.getAttribute('type');

        patternContext.setQueryType('pattern-type');
        patternContext.setQueryTypeValue(type);
        patternContext.setCurrentPage(1);
        patternContext.setLoadPatternData(true);
        patternContext.setLoadMoreButton(true);
    };
    
    const getFavouritePatterns = (event) => {
        //active item.
        activeItem(event);

        console.log('now and on...');

        console.log(patternContext);

        patternContext.setFavouriteContext('');
        patternContext.setLoadFavouritePatternData(true);
    };

    function renderMenuItem() {
        if(Object.keys(patternContext.categoryData).length > 0 && patternContext.letsPrintCatData) {
            return(
                <ul className="pat-main-ul">
                    <li class="pat-main-li pat-main-li-active">
                        <a class="pat-main-li-anchor" onClick={getDefaultData}>
                        {__('All', 'patternly')} ({patternContext.categoryData['types'][0]['count'] + patternContext.categoryData['types'][1]['count']})
                        </a>
                    </li>
                    {
                        patternContext.categoryData['types'].map(category => {

                            return(
                                <li class="pat-main-li" key={category.slug}>
                                    <a class="pat-main-li-anchor" type={category.slug} onClick={getPatternsByType}>
                                        {category.slug === 'pro' && (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M12 3.5C11.613 3.50081 11.2372 3.62985 10.9314 3.86694C10.6256 4.10404 10.407 4.43582 10.3098 4.81037C10.2126 5.18493 10.2422 5.58115 10.3942 5.93705C10.5461 6.29295 10.8117 6.58845 11.1494 6.77734L9.04492 10.9854L5.23438 7.1748C5.39926 6.90993 5.49033 6.60578 5.49815 6.29388C5.50597 5.98197 5.43027 5.67365 5.27887 5.40084C5.12747 5.12803 4.9059 4.90065 4.63708 4.74226C4.36827 4.58387 4.06201 4.50023 3.75 4.5C3.33376 4.50175 2.93177 4.65181 2.6162 4.92324C2.30063 5.19466 2.09213 5.56969 2.02815 5.98099C1.96417 6.39228 2.04889 6.81292 2.26709 7.16739C2.4853 7.52185 2.82271 7.78693 3.21875 7.91504L4.83496 16H19.165L20.7813 7.91699C21.1788 7.78999 21.5178 7.52512 21.7372 7.17016C21.9567 6.8152 22.042 6.39351 21.9779 5.98115C21.9138 5.5688 21.7044 5.19293 21.3876 4.92134C21.0708 4.64975 20.6673 4.50032 20.25 4.5C19.9381 4.50034 19.632 4.58401 19.3634 4.74235C19.0947 4.90069 18.8732 5.12794 18.7219 5.4006C18.5705 5.67326 18.4948 5.98141 18.5024 6.29317C18.5101 6.60493 18.601 6.90897 18.7656 7.17383L14.9551 10.9854L12.8516 6.77832C13.1899 6.58962 13.456 6.294 13.6082 5.9378C13.7605 5.5816 13.7903 5.18496 13.6929 4.81003C13.5955 4.4351 13.3764 4.10308 13.0701 3.866C12.7637 3.62893 12.3874 3.5002 12 3.5ZM5 17.5V19.25C5 20.215 5.785 21 6.75 21H17.25C18.215 21 19 20.215 19 19.25V17.5H5Z" fill="#717D86"/>
                                            </svg>
                                        )}
                                        <span>{category.name} ({category.count})</span>
                                    </a>
                                </li>
                            )
                        })
                    }

                    <li class="pat-main-li">
                        <a class="pat-main-li-anchor" onClick={getFavouritePatterns}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M12.0049 2.50001C11.8647 2.49914 11.7271 2.53756 11.6077 2.61092C11.4882 2.68428 11.3917 2.78964 11.3291 2.91505L8.75293 8.0674L2.63575 9.0088C2.49882 9.02996 2.37043 9.08863 2.26482 9.1783C2.1592 9.26798 2.08049 9.38515 2.0374 9.51683C1.99432 9.64851 1.98855 9.78955 2.02073 9.92431C2.05291 10.0591 2.12179 10.1823 2.21973 10.2803L6.45117 14.5117L5.50879 20.6358C5.48771 20.7728 5.50501 20.9129 5.55877 21.0407C5.61253 21.1685 5.70065 21.2789 5.81334 21.3596C5.92604 21.4403 6.0589 21.4882 6.19717 21.498C6.33545 21.5078 6.47374 21.4791 6.59668 21.4151L12 18.5957L17.4033 21.4151C17.5263 21.4791 17.6646 21.5078 17.8028 21.498C17.9411 21.4882 18.074 21.4403 18.1867 21.3596C18.2994 21.2789 18.3875 21.1685 18.4412 21.0407C18.495 20.9129 18.5123 20.7728 18.4912 20.6358L17.5488 14.5117L21.7803 10.2803C21.8782 10.1823 21.9471 10.0591 21.9793 9.92431C22.0115 9.78955 22.0057 9.64851 21.9626 9.51683C21.9195 9.38515 21.8408 9.26798 21.7352 9.1783C21.6296 9.08863 21.5012 9.02996 21.3643 9.0088L15.2471 8.0674L12.6709 2.91505C12.609 2.79112 12.5141 2.68674 12.3965 2.61349C12.2789 2.54023 12.1434 2.50095 12.0049 2.50001Z" fill="#717D86"/>
                            </svg>
                            <span>{__('Favorites', 'patternly')} ({patternContext.favouriteCount})</span>
                        </a>
                    </li>
                </ul>
                
            )
        }
    }

    return (
        <>
            <div class="pat-main-heading-wrapper">
                <h3 class="pat-main-header">{__('All Patterns', 'patternly')}</h3>

                <div class="pat-main-menu">
                    {renderMenuItem()}

                    <label>
                        <img src={`${PatLocalize.pat_plugin_url}src/admin/assets/images/search.png`} alt="" />
                        <input class="pat-search-box" type="text" onChange={searchPatterns} placeholder="Search patterns" />
                    </label>
                </div>
            </div>
        </>
    );
};

export default PatternlyHeader;